export var replaceMixin = {
  methods: {
    getReplaceProductsFor(itemId) {
      if (this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[itemId]] === undefined) return [];
      var ret = [];
      Object.keys(this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[itemId]].replaceProducts).forEach(key => {
        ret.push([
          parseInt(key),
          parseInt(this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[itemId]].replaceProducts[key])
        ]);
      });

      ret = ret.sort((a, b) => a[1] - b[1]).map(a => this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[a[0]]]);
      return ret;
    },
    shouldReplace(qty, p1Qty, p1Backorder, p1Trigger, p1Time, p2Qty, p2Backorder, p2Trigger, p2Time) {
      if (p1Qty >= qty) return false;
      if (p2Qty >= qty) return true;
      if (p1Backorder === 'ja') {
        if (p1Qty + p1Trigger >= qty && p1Time <= p2Time) return false;
        if (p2Backorder === 'ja') {
          if (p2Qty + p2Trigger >= qty && p1Time >= p2Time) return true;
          if (p1Time <= p2Time) return false;
        }
      }

      return p2Backorder === 'ja';
    }
  }
};
